"use client"

import type React from "react"
import { Inter, Poppins } from "next/font/google"
import "./globals.css"
import Footer from "@/components/footer"
import { MaxWidthWrapper } from "@/components/max-width-wrapper"
import { Toaster } from "@/components/ui/toaster"

const inter = Inter({ subsets: ["latin"] })
const poppins = Poppins({
  weight: ["400", "500", "600", "700"],
  subsets: ["latin"],
  display: "swap",
})

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <html lang="en">
      <head>
        <style jsx global>{`
          .poppins {
            font-family: ${poppins.style.fontFamily};
          }
        `}</style>
      </head>
      <body className={inter.className}>
        <MaxWidthWrapper>
        <div className="flex min-h-screen flex-col">
          <main className="relative">{children}</main>
          <Footer />
        </div>
        </MaxWidthWrapper>
        <Toaster />
      </body>
    </html>
  )
}

